import { Address } from '@spartacus/core';
import {DeliveryMode} from '@spartacus/cart/base/root';

export const ROUTE_PARAMS = {
    budgetCode: 'budgetCode',
    unitCode: 'unitCode',
    costCenterCode: 'costCenterCode',
    userCode: 'userCode',
    userGroupCode: 'userGroupCode',
    permissionCode: 'permissionCode',
    addressCode: 'addressId',
};

export const MAX_OCC_INTEGER_VALUE = 2147483647;

export enum UigOrganizationTableType {
  BRANCHES = 'branches',
  UIG_USER = 'uigOrgUser'
}

declare module '@spartacus/organization/administration/components' {
  export enum OrganizationTableType {
    BRANCHES = 'branches',
    UIG_USER = 'uigOrgUser'
  }
}

export interface DeliveryData {
  deliveryModes: DeliveryMode[];
  deliveryAddresses: Address[];
}
